export default "__VITE_ASSET__67c44f24__"